export default {
  state: {
    isMp: {}, // 判断是否小程序 未使用
    imgUrl: {} // 保存压缩后的图片地址
  },
  getter: {
    consoleChatText: state => {
      console.log(state.isMp, 'state.isMp')
    },
    consoleImgUrl: state => {
      console.log(state.imgUrl, 'imgUrl')
    }
  },
  mutations: {
    setIsMp: (state, val) => {
      state.isMp = val
    },
    setImgUrl: (state, val) => {
      state.imgUrl = val
    }
  },
  actions: {
    setIsMp: (context, val) => {
      context.commit('setIsMp', val)
    },
    setImgUrl: (context, val) => {
      context.commit('setImgUrl', val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/utillStore/utill.js